import gql from 'graphql-tag'

export default gql`
  mutation membership_affiliates_update_mutation(
    $id: ID!
    $applicationFeePercent: Int!
    $name: String!
    $slug: String!
    $stripeAccountId: String!
    $stripeCouponId: String
  ) {
    membershipAffiliateUpdate(
      id: $id
      applicationFeePercent: $applicationFeePercent
      name: $name
      slug: $slug
      stripeAccountId: $stripeAccountId
      stripeCouponId: $stripeCouponId
    ) {
      id
      applicationFeePercent
      name
      slug
      stripeCouponId
      stripeAccountId
    }
  }
`
